import './index.scss'
import {HelpIcon} from '../../../icons'
import InputInfo from '../inputInfo'
import {useEffect, useRef, useState} from 'react'
import Error from '../error'
import classNames from 'classnames'
import useOnClickOutside from '../../../utils/hooks/useOutsideClick'
import {useSelector} from 'react-redux'

const Textarea = ({
    name,
    placeholder,
    value = '',
    onChange,
    defaultValue,
    innerRef,
    error,
    infoText,
    isDisabled,
    activeInfo,
    handleInfo,
    minLength = null,
    placeholderAsLabel = true,
    customIcon,
    customIconOnclick,
    ...props
}) => {
    const [helpInfoIsActive, setHelpInfoIsActive] = useState(activeInfo)
    const [charCount, setCharCount] = useState(0)
    const [hasValue, setHasValue] = useState(false)

    const ref = useRef()
    const infoRef = useRef()
    useOnClickOutside(infoRef, () => setHelpInfoIsActive(false))
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    const placeholderClassName = hasValue ? 'has-value' : 'empty'

    const setHelpInfoStatus = () => {
        setHelpInfoIsActive(!helpInfoIsActive)
        typeof handleInfo === 'function' && handleInfo(!helpInfoIsActive)
    }

    const handleChange = e => {
        const length = e.target.value.length
        setCharCount(length)
        onChange(e)
    }

    const getCountClass = () => {
        if (minLength && charCount) {
            return charCount >= minLength ? 'success' : 'error'
        }
        return ''
    }

    const updateLabelVisibility = () => {
        if (placeholderAsLabel) {
            const inputText = ref?.current?.value
            const condition = inputText?.length
            setHasValue(condition)
        }
    }

    useEffect(() => {
        if (value?.length === 0) {
            setCharCount(0)
        }
        updateLabelVisibility()
    }, [value])

    useEffect(() => {
        setHelpInfoIsActive(activeInfo)
    }, [activeInfo])
    return (
        <div className="form-element">
            <div className={classNames('textarea', {
                dark: isDarkMode
            })}>
                <textarea
                    onInput={updateLabelVisibility}
                    placeholder={!placeholderAsLabel && placeholder}
                    name={name}
                    onChange={handleChange} disabled={isDisabled}
                    ref={ref || innerRef}
                    id={name}
                    value={value}
                    defaultValue={defaultValue}
                    className={classNames({
                        'simple-textarea': true,
                        error,
                        [placeholderClassName]: placeholderAsLabel,
                        dark: isDarkMode
                    })}
                    {...props}
                />
                {placeholderAsLabel && (
                    <span className={classNames({
                        'input-placeholder': true,
                        [placeholderClassName]: placeholderClassName
                    })}>{placeholder}</span>
                )}
                {infoText && (
                    <div ref={infoRef} className={`help ${helpInfoIsActive ? 'active' : ''}`} onClick={setHelpInfoStatus}>
                        <span><HelpIcon/></span>
                        <InputInfo text={infoText}/>
                    </div>
                )}
                {customIcon && (
                    <div className="help" onClick={customIconOnclick}>
                        <span>{customIcon}</span>
                    </div>
                )}
            </div>
            <div className={classNames({
                'validation-box': true,
                'justify-content-start': !minLength
            })}>
                {minLength && <span className={`count ${getCountClass()}`}>{charCount}</span>}
                {error && <Error error={error}/>}
            </div>
        </div>
    )
}

export default Textarea
